/**
 * 系统常量
 *
 * @author Jay Qing
 */
/**
 * 用户状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const COMMON_ENABEL_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}
/**
 * 用户状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
 export const USER_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}

/**
 * 用户性别
 *
 * @type {{MALE: {CODE: string, NAME: string}, FEMALE: {CODE: string, NAME: string}}}
 */
export const USER_GENDER = {
  /**
   * 男
   */
  MALE: {
    NAME: '男',
    CODE: 'M'
  },
  /**
   * 女
   */
  FEMALE: {
    NAME: '女',
    CODE: 'F'
  }
}

/**
 * 角色状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const ROLE_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}

/**
 * 部门状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const DEPARTMENT_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}

/**
 * 菜单状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const MENU_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}

/**
 * 菜单操作状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const MENU_ACTION_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}

/**
 * 菜单可见性
 *
 * @type {{VISIBLE: {CODE: string, NAME: string}, INVISIBLE: {CODE: string, NAME: string}}}
 */
export const MENU_VISIBILITY = {
  /**
   * 显示
   */
  VISIBLE: {
    NAME: '显示',
    CODE: '1'
  },
  /**
   * 隐藏
   */
  INVISIBLE: {
    NAME: '隐藏',
    CODE: '0'
  }
}

/**
 * 菜单类型
 *
 * @type {{LOCAL: {CODE: string, NAME: string}, URL: {CODE: string, NAME: string}}}
 */
export const MENU_TYPE = {
  /**
   * 本地菜单
   */
  LOCAL: {
    NAME: '本地',
    CODE: '0'
  },
  /**
   * 外链
   */
  URL: {
    NAME: '外链',
    CODE: '1'
  }
}

/**
 * 菜单缓存
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const MENU_KEEP_ALIVE = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '开启',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '关闭',
    CODE: '0'
  }

}

/**
 * 菜单类型
 *
 * @type {{CATALOG: string, ACTION: string, MENU: string}}
 */
export const MENU_STYLE = {

  /**
   * 目录
   */
  CATALOG: 'C',

  /**
   * 页面
   */
  MENU: 'M',

  /**
   * 操作
   */
  ACTION: 'A'

}

/**
 * 外链类型
 *
 * @type {{IFRAME: string, FORWARD: string}}
 */
export const URL_TYPE = {
  /**
   * 跳转
   */
  FORWARD: 'forward',
  /**
   * 内嵌
   */
  IFRAME: 'iframe'
}

/**
 * 字典状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const DICTIONARY_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}

/**
 * 字典数据状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const DICTIONARY_DATA_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}

/**
 * 任务状态
 *
 * @type {{DISABLED: {CODE: string, NAME: string}, ENABLED: {CODE: string, NAME: string}}}
 */
export const JOB_STATUS = {
  /**
   * 启用
   */
  ENABLED: {
    NAME: '启用',
    CODE: '1'
  },
  /**
   * 禁用
   */
  DISABLED: {
    NAME: '停用',
    CODE: '0'
  }
}

/**
 * 任务状态
 *
 * @type {{RUNNING: {CODE: string, NAME: string},
 * PENDING: {CODE: string, NAME: string},
 * STOPPED: {CODE: string, NAME: string}}}
 */
export const JOB_RUN_STATE = {
  /**
   * 正在运行
   */
  RUNNING: {
    NAME: '正在运行',
    CODE: 'R'
  },
  /**
   * 等待运行
   */
  PENDING: {
    NAME: '等待运行',
    CODE: 'P'
  },
  /**
   * 停止运行
   */
  STOPPED: {
    NAME: '停止运行',
    CODE: 'S'
  }
}

/**
 * 任务执行结果
 *
 * @type {{FAILED: {CODE: string, NAME: string},
 * SUCCESS: {CODE: string, NAME: string},
 * ERROR: {CODE: string, NAME: string}}}
 */
export const JOB_RUN_RESULT = {
  /**
   * 失败
   */
  FAILED: {
    NAME: '失败',
    CODE: '0'
  },
  /**
   * 成功
   */
  SUCCESS: {
    NAME: '成功',
    CODE: '1'
  },
  /**
   * 异常
   */
  ERROR: {
    NAME: '异常',
    CODE: '2'
  }
}

/**
 * 任务日志策略
 *
 * @type {{DISABLED: {CODE: string, NAME: string},
 * ALL: {CODE: string, NAME: string},
 * ERROR: {CODE: string, NAME: string}}}
 */
export const JOB_LOG_STRATEGY = {
  /**
   * 不记录日志
   */
  DISABLED: {
    NAME: '不记录日志',
    SHORT_NAME: '关闭',
    CODE: '0'
  },
  /**
   * 记录全部日志
   */
  ALL: {
    NAME: '记录全部日志',
    SHORT_NAME: '全部',
    CODE: '1'
  },
  /**
   * 仅记录错误日志
   */
  ERROR: {
    NAME: '仅记录错误日志',
    SHORT_NAME: '错误',
    CODE: '2'
  }
}

/**
 * 邮件类型
 *
 * @type {{HTML: {CODE: string, NAME: string}, TEXT: {CODE: string, NAME: string}}}
 */
export const MAIL_TYPE = {
  /**
   * HTML邮件
   */
  HTML: {
    NAME: 'HTML',
    CODE: '1'
  },
  /**
   * 普通文本邮件
   */
  TEXT: {
    NAME: 'TEXT',
    CODE: '0'
  }
}

/**
 * 邮件联系人来自
 * @type {{MAIL_RECIPIENT: {CODE: string, NAME: string}, SYSTEM_USER: {CODE: string, NAME: string}}}
 */
export const MAIL_RECIPIENT_FROM = {
  /**
   * 系统用户
   */
  SYSTEM_USER: {
    NAME: '系统用户',
    CODE: '0'
  },
  /**
   * 邮件联系人
   */
  MAIL_RECIPIENT: {
    NAME: '邮件联系人',
    CODE: '1'
  }
}

/**
 * 消息/公告接收人类型
 *
 * @type {{ALL: {CODE: string, NAME: string}, DEPT: {CODE: string, NAME: string}, USER: {CODE: string, NAME: string}}}
 */
export const MESSAGE_RECIPIENT = {
  /**
   * 全部
   */
  ALL: {
    NAME: '全部',
    CODE: '0'
  },
  /**
   * 部门
   */
  DEPT: {
    NAME: '部门',
    CODE: '1'
  },
  /**
   * 用户
   */
  USER: {
    NAME: '用户',
    CODE: '2'
  }
}

/**
 * 公告/消息类型
 *
 * @type {{MESSAGE: {CODE: string, NAME: string}, NOTICE: {CODE: string, NAME: string}}}
 */
export const MESSAGE_TYPE = {
  /**
   * 公告
   */
  NOTICE: {
    NAME: '公告',
    CODE: '0'
  },
  /**
   * 消息
   */
  MESSAGE: {
    NAME: '消息',
    CODE: '1'
  }
}

/**
 * 公告/消息状态
 *
 * @type {{PUBLISHED: {CODE: string, NAME: string}, DRAFTED: {CODE: string, NAME: string}}}
 */
export const MESSAGE_STATUS = {
  /**
   * 未发布
   */
  DRAFTED: {
    NAME: '未发布',
    CODE: '0'
  },
  /**
   * 已发布
   */
  PUBLISHED: {
    NAME: '已发布',
    CODE: '1'
  }
}

/**
 * 公告/消息阅读状态
 *
 * @type {{READ: {CODE: string, NAME: string}, UNREAD: {CODE: string, NAME: string}}}
 */
export const MESSAGE_READ_STATUS = {
  /**
   * 未读
   */
  UNREAD: {
    NAME: '未读',
    CODE: '0'
  },
  /**
   * 已读
   */
  READ: {
    NAME: '已读',
    CODE: '1'
  }
}

/**
 * 导入结果
 *
 * @type {{SUCCESS: string, ERROR: string}}
 */
export const IMPORT_RESULT = {
  /**
   * 成功
   */
  SUCCESS: '1',
  /**
   * 失败
   */
  ERROR: '2'
}

/**
 * 异步任务状态
 *
 * @type {{READ: {CODE: string, NAME: string}, UNREAD: {CODE: string, NAME: string}}}
 */
export const ASYN_TASK_STATUS = {
  /**
   * 任务已经启动
   */
  STARTED: {
    NAME: '任务已启动',
    CODE: '0'
  },
  /**
   * 任务正在运行
   */
  RUNNING: {
    NAME: '任务正在运行',
    CODE: '1'
  },
  /**
   * 任务执行成功
   */
  SUCCESS: {
    NAME: '任务执行成功',
    CODE: '2'
  },
  /**
   * 任务执行成功
   */
  FAILED: {
    NAME: '任务执行失败',
    CODE: '-1'
  }
}

/**
 * 客户端资源类型
 *
 * @type {{READ: {CODE: string, NAME: string}, UNREAD: {CODE: string, NAME: string}}}
 */
export const RESOURCES_TYPE = {
  /**
   * 服务
   */
  STARTED: {
    NAME: '服务端',
    CODE: '0'
  },
  /**
   * 前端
   */
  RUNNING: {
    NAME: 'Web端',
    CODE: '1'
  }
}

/**
 * 日志响应状态
 *
 * @type {{READ: {CODE: string, NAME: string}, UNREAD: {CODE: string, NAME: string}}}
 */
export const LOG_RESULT_TYPE = {
  /**
   * 服务
   */
  NORMAL: {
    NAME: '正常',
    CODE: '0'
  },
  /**
   * 前端
   */
  ERROR: {
    NAME: '异常',
    CODE: '1'
  }
}

/**
 * 请假类型
 *
 * @type {{READ: {CODE: string, NAME: string}, UNREAD: {CODE: string, NAME: string}}}
 */
export const LEAVE_DEMO_STATUS = {

  SAVED: {
    NAME: '已保存',
    CODE: '0'
  },

  leader: {
    NAME: '领导待审核',
    CODE: '1'
  },
  admin: {
    NAME: '管理员待审核',
    CODE: '2'
  },
  pass: {
    NAME: '审批通过',
    CODE: '3'
  },
  refuse: {
    NAME: '审批未通过',
    CODE: '4'
  }
}

